var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.noHeader)?_c('v-header'):_vm._e(),_c('div',{staticClass:"bg242",class:_vm.content()},[_c('keep-alive',{attrs:{"include":"home,goods"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }